<template>
    <p class="pn-legend">
        <b>2PN</b> - {{$translate('normal_fertilization')}}

        <span class="vd">|</span>

        <b>0PN</b> - {{$translate('no_fertilization')}}

        <span class="vd">|</span>

        <b>1/3/4PN</b> - {{$translate('abnormal_fertilization')}}
    </p>
</template>

<script>
export default {
    name: 'PnLegend'
}
</script>

<style lang="scss" scoped>
.pn-legend {
    margin-bottom: 0;

    .vd {
        margin: 0 20px;
    }
}
</style>
